<template>
  <div class="outer-wrapper">
    <div v-if="currentTask.name&&toggleShow==='operate'">
        <van-nav-bar
        title="任务执行确认"
        left-text="返回"
        left-arrow
        @click-left="goBack"
        fixed
      >
      </van-nav-bar>
      <van-cell :value="currentTask.name" value-class="title-p"/>
      <van-cell :value="currentTask.standard" value-class="sub-title-p"/>
      <van-cell title="检测组" :value="currentTask.group_name" value-class="prop-value" title-class="prop-title"/>
      <van-cell title="所需样品信息" :value="'共'+(currentTask.sampleList ? currentTask.sampleList.length : 0)+'件'" value-class="prop-value" title-class="prop-title"/>
      <div class="sample-list-wrapper">
          <div class="sample-list-inner-wrapper">
              <p v-if="currentTask.sampleList && currentTask.sampleList.length > 0" class="prop-value">
                <span v-for="(sample, index) in currentTask.sampleList" :key="index">
                  {{ (sample.name?sample.name:sample)+'；' }}
                </span>
              </p>
              <p v-else>
                <span>无</span>
              </p>
          </div>
      </div>
      <van-cell
        title="约定完成日期"
        :value="currentTask.plan_complete_time?currentTask.plan_complete_time.split(' ')[0]:'-'"
        value-class="prop-value"
        title-class="prop-title"
      />
      <van-cell title="检测次数" :value="currentTask.times" value-class="prop-value" title-class="prop-title"/>
      <van-cell title="必要工时(小时)" :value="getWorkTime(currentTask)" value-class="prop-value" title-class="prop-title"/>
      <van-cell title="全部工时(小时)" :value="getPromiseTime(currentTask)" value-class="prop-value" title-class="prop-title"/>
      <van-collapse v-model="activeCollapse">
  <van-collapse-item title="时间节点信息" name="1">
    <van-cell title="订单创建时间" :value="currentTask.order_time" value-class="prop-value" title-class="prop-title"/>
      <van-cell title="任务计划时间" :value="currentTask.plan_time" value-class="prop-value" title-class="prop-title"/>
      <van-cell title="样品完备时间" :value="currentTask.ready_time" value-class="prop-value" title-class="prop-title"/>
      <van-cell title="任务接收时间" :value="currentTask.accept_time" value-class="prop-value" title-class="prop-title" v-show="currentTask.accept_time"/>
      <van-cell title="任务分配时间" :value="currentTask.allot_time" value-class="prop-value" title-class="prop-title" v-show="currentTask.allot_time"/>
  </van-collapse-item>
</van-collapse>
      
      <van-cell title="任务记录" is-link @click="taskRecordShow"/>
      <van-cell center title="是否生成原始记录编号">
        <template #right-icon>
          <van-switch v-model="ifRecord" size="24" />
        </template>
      </van-cell>

      <van-checkbox-group v-model="choosedEquipments">
  <van-cell-group title="请选择设备">
    <van-cell
      v-for="(ele,ei) in currentTask.equipments"
      clickable
      :key="ei+'equip'"
      :title="ele.equipnum+' '+ele.name"
      @click="toggle(ei)"
    >
      <template #right-icon>
        <van-checkbox :name="ele" ref="checkboxes" />
      </template>
    </van-cell>
  </van-cell-group>
</van-checkbox-group>
<div style="height:3rem;">
</div>
      <van-button type="primary" class="submit-b" block @click="confirm">开始检测</van-button>
    </div>
    <div v-else-if="currentTask.name&&toggleShow==='record'">
        <van-nav-bar
        :title="'任务操作记录('+(currentTask.name)+')'"
        left-text="返回"
        left-arrow
        @click-left="onClickBack"
        fixed
      ></van-nav-bar>
      <div v-if="recordList.length > 0">
        <van-cell-group
          :title="record.op_c==='plan'?'':record.op_time"
          v-for="(record, ri) in recordList"
          :key="ri"
          
        >
          <van-cell :value="record.op_text + (record.op_c==='plan'?('---'+record.op_time):'')+'；'" value-class="record-value" :icon="record.op_c==='plan'?'underway-o':''"/>
        </van-cell-group>
      </div>
      <div v-else>
          <van-empty description="暂无" />
      </div>
    </div>
    <div v-else-if="!currentTask.name">
        <van-empty description="该任务已失效（订单取消/流程更改...）" />
    </div>
    <div class="spin" v-else>
      <van-loading type="spinner" color="#1989fa" />
    </div>
  </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
import { textTrans } from "@/mixins/TextTrans.js";
import { orderTime } from "@/mixins/OrderTime.js";
//let authData = JSON.parse(localStorage.getItem("authData"));
import dayjs from 'dayjs';

export default {
  name: "taskAllot",
  components: {},
  mixins: [textTrans,orderTime],
  props:{
    enid:{
      type: String,
      default: ''
    }
  },
  data() {
    return {
      toggleShow:'operate',
      activeCollapse:[1],
      currentTask:{},
      recordList:[],
      choosedEquipments:[],
      ifRecord:true
    };
  },
  watch: {
  },
  computed: {
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$axios
        .post(this.$url + "/inspection_do", {
          userToken: userToken,
          ask_data: "taskInfo",
          enid:this.enid
        })
        .then(response => {
          if(response.data.stat==='ok'){
            this.currentTask = response.data.res_record;
            this.recordList = response.data.recordList;
            this.recordList.sort((a,b)=>dayjs(a.final_index)-dayjs(b.final_index));
            for(let i of this.currentTask.equipments){
              if(i.ifDefault){
                this.choosedEquipments.push(i);
              }
            }
          }else{
            this.$toast.fail('未找到数据！');
          }
        });
    },
    confirm(){
      console.log(this.choosedEquipments);
        this.$dialog.confirm({
        title: this.currentTask.name,
        message: '确认开始执行该检测项目',
        beforeClose:(action,done)=>{
            if(action==='confirm'){
              if(this.choosedEquipments.length>0||this.currentTask.equipments.length===0){
                this.toggleShow = 'spin';
                this.$axios
                    .post(this.$url + "/inspection_do", {
                    userToken: userToken,
                    choosedEquipments:this.choosedEquipments,
                    ifRecord:this.ifRecord,
                    ask_data: "taskStart",
                    enid:this.enid
                    })
                    .then(response => {
                    if(response.data.stat==='ok'){
                        done();
                        this.$toast.success('操作成功！');
                        window.location.href = '/task/' + this.enid;//转到我的任务列表
                    }else{
                        done();
                        this.$toast.fail('未找到数据！');
                    }
                    });

              }else{
                this.$toast.fail('请至少选择一个检测设备！');
                done();
              }
                
            }else if(action==='cancel'){
                done();
            }else{
                done();
            }
        },
        }).catch(
            ()=>{
            }
        );
    },
    onClickBack(){
       this.toggleShow = 'operate';
    },
    taskRecordShow(){
        this.toggleShow = 'record';
    },
    goBack(){
        // this.$router.go(-1);
        window.location.href = '/myTask';
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
  }
};
</script>
<style scoped>
.title-p{
    font-weight: 700;
    font-size:0.9rem;
    text-align: center;
}
.sub-title-p{
    text-indent: 1.2rem;
    color:#999;
}

.prop-title{
    color:#999;
    font-size: 0.6rem;
}
.prop-value{
    color:#333;
    font-size: 0.7rem;
}
.spin{
  text-align: center;
  padding-top: 40%;
  
}

.sample-list-wrapper{
    text-align: center;
    width:100%;
    word-break:break-all;
}

.sample-list-inner-wrapper{
    margin:0.5rem 0.6rem;
}

.submit-b{
    position: fixed;
    bottom:0;
}

.record-value{
    text-indent: 1rem;
}



</style>